// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  SERVER_URL: '',
  // SERVER_URL: 'http://192.168.5.11:8067',
  // SERVER_URL: 'http://192.168.4.11:8067',
  // SERVER_URL: 'http://localhost:8086',
  useHash: true,
  hmr: false,
  notificationModule: '/notification',
  operationModule: '/operation',
  taskModule: '/task'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
